<template>
  <el-menu
    :collapse="isCollapse"
    router
    collapse-transition
    @mouseover.native="expandSidebar"
    @mouseleave.native="collapseSidebar"
  >
    <div>
      <div
        class="tw-bg-primary tw-pt-[7px] tw-px-[2px] tw-pb-[5px]"
      >
        <icon-logo />
      </div>
      <NavItemV2
        to="/notifications"
        :label="$t('main.navigation.notifications')"
      >
        <template #icon>
          <el-badge
            :value="unseenNotificationsCount.count"
            class="item"
            :hidden="unseenNotificationsCount.count === 0"
            :max="9"
          >
            <icon-notification />
          </el-badge>
        </template>
      </NavItemV2>
      <NavItemV2
        v-if="me.role === $roles.ADMIN"
        to="/dashboard"
        :label="$t('main.navigation.dashboard')"
      >
        <template #icon>
          <icon-dashboard />
        </template>
      </NavItemV2>
      <NavItemV2
        to="/foreigners"
        :label="$t('main.navigation.foreigners')"
      >
        <template #icon>
          <icon-foreigner />
        </template>
      </NavItemV2>
      <el-sub-menu
        v-if="me.role === $roles.ADMIN"
        index="1"
      >
        <template #title>
          <SubMenuTitleV2 :label="$t('main.navigation.administration')">
            <template #icon>
              <icon-administration />
            </template>
          </SubMenuTitleV2>
        </template>
        <el-sub-menu index="1-1">
          <template #title>
            <SubMenuTitleV2
              :is-inner-menu="true"
              :label="$t('main.navigation.administration.agency')"
            >
              <template #icon>
                <div />
              </template>
            </SubMenuTitleV2>
          </template>
          <NavItemV2
            to="/administration/agency/companies"
            :label="$t('main.navigation.administration.agency.companies')"
          />

          <NavItemV2
            to="/administration/agency/users"
            :label="$t('main.navigation.administration.agency.users')"
          />
        </el-sub-menu>
        <el-sub-menu index="1-2">
          <template #title>
            <SubMenuTitleV2
              :is-inner-menu="true"
              :label="$t('main.navigation.administration.clients')"
            >
              <template #icon>
                <div />
              </template>
            </SubMenuTitleV2>
          </template>
          <NavItemV2
            to="/administration/clients/companies"
            :label="$t('main.navigation.administration.clients.companies')"
          />
          <NavItemV2
            to="/administration/clients/users"
            :label="$t('main.navigation.administration.clients.users')"
          />
        </el-sub-menu>
        <el-sub-menu index="1-3">
          <template #title>
            <SubMenuTitleV2
              :is-inner-menu="true"
              :label="$t('main.navigation.administration.internal')"
            >
              <template #icon>
                <div />
              </template>
            </SubMenuTitleV2>
          </template>
          <NavItemV2
            to="/administration/internal/users"
            :label="$t('main.navigation.administration.internal.users')"
          />
          <NavItemV2
            to="/administration/internal/places"
            :label="$t('main.navigation.administration.internal.places')"
          />
          <NavItemV2
            to="/administration/internal/faq"
            :label="$t('main.navigation.administration.internal.faq')"
          />
        </el-sub-menu>
        <el-sub-menu index="1-4">
          <template #title>
            <SubMenuTitleV2
              :is-inner-menu="true"
              :label="$t('main.navigation.administration.permits')"
            >
              <template #icon>
                <div />
              </template>
            </SubMenuTitleV2>
          </template>
          <NavItemV2
            to="/administration/permit/documents"
            :label="$t('main.navigation.administration.permits.documents')"
          />
          <NavItemV2
            to="/administration/permit/statuses"
            :label="$t('main.navigation.administration.permits.statuses')"
          />
          <NavItemV2
            to="/administration/permit/action_dates"
            :label="$t('main.navigation.administration.permits.action_dates')"
          />
          <NavItemV2
            to="/administration/permit/types"
            :label="$t('main.navigation.administration.permits.types')"
          />
        </el-sub-menu>
        <el-sub-menu index="1-5">
          <template #title>
            <SubMenuTitleV2
              :is-inner-menu="true"
              :label="$t('main.navigation.administration.log')"
            >
              <template #icon>
                <div />
              </template>
            </SubMenuTitleV2>
          </template>
          <NavItemV2
            to="/administration/audit_log"
            :label="$t('main.navigation.administration.log.audit_log')"
          />
        </el-sub-menu>
      </el-sub-menu>
    </div>
    <div>
      <NavItemV2
        to="/me"
        :label="$t('main.navigation.my_account')"
      >
        <template #icon>
          <icon-settings />
        </template>
      </NavItemV2>
      <NavItemV2
        to="/faq"
        :label="$t('main.navigation.faq')"
        @click.stop="logout"
      >
        <template #icon>
          <icon-faq />
        </template>
      </NavItemV2>
      <NavItemV2
        :label="$t('main.navigation.logout')"
        @click="logout"
      >
        <template #icon>
          <icon-logout />
        </template>
      </NavItemV2>
    </div>
  </el-menu>
</template>

<script>
import NavItemV2 from '@/components/Navigation/NavItemV2.vue';
import SubMenuTitleV2 from '@/components/SubMenuTitleV2.vue';
import { authComputed } from '@/vuex/helpers';
import { mapState } from 'vuex';

export default {
  name: 'AdminAppNavV2',
  components: { SubMenuTitleV2, NavItemV2 },
  data() {
    return {
      isCollapse: true,
    };
  },
  computed: {
    ...authComputed,
    ...mapState({
      interfaceLanguages: (state) => state.v2.shared.enums.interface_languages,
      me: (state) => state.v2.shared.profile.me,
      unseenNotificationsCount: (state) => state.v2.shared.notifications.unseenCount,
    }),
  },
  created() {
    if (this['auth/loggedIn']) {
      this.refreshNotificationsCount();

      this.$refreshNotificationsInterval = setInterval(() => {
        this.refreshNotificationsCount();
      }, 30 * 1000);
    }
  },
  methods: {
    expandSidebar() {
      this.isCollapse = false;
    },
    collapseSidebar() {
      this.isCollapse = true;
    },
    logout() {
      clearInterval(this.$refreshNotificationsInterval);
      this.$store.dispatch('auth/logout');
    },
    refreshNotificationsCount: function() {
      this.$store.dispatch('v2/shared/notifications/loadUnseenCount');
    },
  },
};
</script>
